module.exports = __webpack_public_path__ + "static/img/fla.9328296.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icon_suffix/fla.png
// module id = 3Xvf
// module chunks = 53